import React, { useState } from 'react';
import { Search, Loader } from 'lucide-react';
import { aiAPI } from '../services/api';
import toast from 'react-hot-toast';
import MarkdownRenderer from './MarkdownRenderer';
import StatsAndTabs from './StatsAndTabs';

const LegalResearch = ({ onSuccess, stats, loading: statsLoading }) => {
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!query.trim()) {
      toast.error('Please enter a research query');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      const response = await aiAPI.researchLegal({ query });

      setResult(response.result);
      toast.success('Legal research completed!');
      
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Legal research failed:', error);
      toast.error('Failed to conduct legal research');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setQuery('');
    setResult('');
  };

  return (
    <div>
      <div className="content-header">
        <div className="welcome-section">
          <h2>Legal Research</h2>
          <p>Conduct comprehensive legal research with AI assistance</p>
        </div>
      </div>

      <StatsAndTabs stats={stats} loading={statsLoading} />

      <div className="tool-content">
        <div className="tool-header">
          <Search size={24} />
          <h3>Legal Research</h3>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Research Query</label>
            <textarea
              className="form-textarea"
              placeholder="Enter your legal research question or topic..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              disabled={loading}
              style={{ minHeight: '120px' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader size={16} className="animate-spin" />
                  Researching...
                </>
              ) : (
                <>
                  <Search size={16} />
                  Start Research
                </>
              )}
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClear}
              disabled={loading}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {result && (
        <div className="tool-content">
          <div className="tool-header">
            <Search size={24} />
            <h3>Research Results</h3>
          </div>
          
          <MarkdownRenderer content={result} />

          <div style={{ marginTop: '16px' }}>
            <button
              className="btn btn-secondary"
              onClick={() => navigator.clipboard.writeText(result)}
            >
              Copy Results
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LegalResearch;
